module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/image4-d9f672d826c69af93684994fe2ece697.png";